import { useJWTokens, useJWTUser } from 'contexts/JWTContext';
import { GetUserClaim, IsUserInRole } from 'models/jwt/identity';
import React, { useMemo } from 'react';
import {
  Button, Container, Nav, Navbar,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from 'images/digitach-logo.png';

const Logout = () => {
  const [, setJwt] = useJWTokens();

  const logout = () => {
    setJwt(undefined);
  };

  return (
    <Button size="sm" variant="secondary" onClick={logout}>
      Log ud
    </Button>
  );
};

const LoginNav = () => {
  const user = useJWTUser();
  const name = useMemo(() => user && GetUserClaim<string>(user, 'email'), [user]);

  return (
    <Navbar.Collapse className="justify-content-end">
      {name ? (
        <>
          <Navbar.Text>
            Logget ind som:
            {' '}
            <b>{name}</b>

          </Navbar.Text>
          <Logout />

        </>

      ) : (
        <Nav.Link href="login">Log-ind</Nav.Link>
      )}
    </Navbar.Collapse>
  );
};

const DefaultNavmenu = () => (
  <Navbar bg="light">
    <Container>
      <Navbar.Brand as={Link} to="/"><img src={Logo} alt="DigiTach" className="nav-logo" /></Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link as={Link} to="/">Sikker upload</Nav.Link>
        </Nav>
      </Navbar.Collapse>
      <LoginNav />
    </Container>
  </Navbar>
);

const AdminNavmenu = () => (
  <Navbar bg="light">
    <Container>
      <Navbar.Brand as={Link} to="/"><img src={Logo} alt="DigiTach" className="nav-logo" /></Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link as={Link} to="/">Sikker upload</Nav.Link>
          <Nav.Link as={Link} to="/admin/access">Sikre adgange</Nav.Link>
          <Nav.Link as={Link} to="/admin/users">Admin brugere</Nav.Link>
        </Nav>
      </Navbar.Collapse>
      <LoginNav />
    </Container>
  </Navbar>
);

export const Navmenu = () => {
  const user = useJWTUser();
  const isAdmin = useMemo(() => user && IsUserInRole(user, 'Admin'), [user]);

  return isAdmin ? <AdminNavmenu /> : <DefaultNavmenu />;
};

export default Navmenu;
